// Camion dompeur : chaque tonne livrée est facturée à la coop de la commande ; rien n'est facturé à l'heure, inspection comprise.
export const isDompeurSheet = sheet => sheet?.dispatch_assignment?.truck_type === "dompeur";

const present = value => value != null && String(value).trim() !== "";

// $/t de la commande (Data Manager ou signe $ du relevé), sinon le tarif dompeur des Paramètres de Facturation.
export function dompeurRate(order, fee, quantity = (row, field) => row[field]) {
  const own = quantity(order, "loading_tonne_rate_override");
  if (present(own)) return { rate: Number(own), automatic: false };
  return { rate: present(fee?.dompeur_tonne_rate) ? Number(fee.dompeur_tonne_rate) : null, automatic: true };
}

// Tonnes livrées par entreprise facturée, dans l'ordre des arrêts ; sans « Facturer à » valide, la commande garde le nom de son client.
export function dompeurTonnesParts(sheet, fee) {
  const parts = new Map();
  for (const visit of sheet.visits || []) {
    if (visit.kind !== "delivery" || visit.status === "not_performed") continue;
    for (const order of visit.orders || []) {
      const tons = Number(order.delivered_tons);
      if (order.execution_excluded || order.separate_treatment || !(tons > 0)) continue;
      const valid = Boolean(order.coop) && order.coop_valid !== false;
      const label = valid ? order.coop_party?.display_name || order.coop : visit.label;
      const part = parts.get(label) || { key: label, label, tons: 0, rates: new Set(), missingCoop: !valid, missingRate: false, stops: new Set() };
      const { rate } = dompeurRate(order, fee);
      part.tons += tons;
      part.stops.add(String(visit.id));
      if (rate == null) part.missingRate = true;
      else part.rates.add(rate);
      parts.set(label, part);
    }
  }
  return [...parts.values()];
}
